export const buildOAuthSuccessLoginRedirectUrl = (search = ''): string => {
    const normalizedSearch = search.trim();
    if (!normalizedSearch) {
        return '/admin/auth';
    }

    return `/admin/auth${normalizedSearch.startsWith('?') ? normalizedSearch : `?${normalizedSearch}`}`;
};
